'use strict';

import ScrollMagic from 'scrollmagic/scrollmagic/uncompressed/ScrollMagic';
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

/**
 * @classname CompanyParallax
 * @classdesc Companyパララックス
 */
export default class CompanyParallax {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('CompanyParallax.constructor');
		this._controller = new ScrollMagic.Controller();
		this.companyDetailAnimation();
		this.mapAnimation();
		this.messageAnimation();
		this.historyAnimation();
	};


	/**
	 * 会社概要
	 *
	 * @memberof CompanyParallax
	 * @return {undefined}
	 */
	companyDetailAnimation() {
		console.log('CompanyParallax.companyDetailAnimation');
		const item = $('.dl--company-detail');
		for(let i = 0; i < item.length; i++){
			new ScrollMagic.Scene({
				triggerElement: item[i],
				triggerHook: 'onEnter',
				offset: 50
			})
				.setClassToggle(item[i], 'visible')
				.addTo(this._controller);
		}
	};


	/**
	 * 地図
	 *
	 * @memberof CompanyParallax
	 * @return {undefined}
	 */
	mapAnimation() {
		console.log('CompanyParallax.mapAnimation');
		const item = $('.block--office-info');
		for(let i = 0; i < item.length; i++){
			new ScrollMagic.Scene({
				triggerElement: item[i],
				triggerHook: 'onEnter',
				offset: 50
			})
				.setClassToggle(item[i], 'visible')
				.addTo(this._controller);
		}
		const map = $('.block--map');
		for(let i = 0; i < map.length; i++){
			new ScrollMagic.Scene({
				triggerElement: map[i],
				triggerHook: 'onEnter',
				offset: 50
			})
			.setClassToggle(map[i], 'visible')
			.addTo(this._controller);
		}
	};


	/**
	 * メッセージ
	 *
	 * @memberof CompanyParallax
	 * @return {undefined}
	 */
	messageAnimation() {
		console.log('CompanyParallax.messageAnimation');
		new ScrollMagic.Scene({
			triggerElement: '.image-box--ceo',
			triggerHook: 'onEnter',
			offset: 50
		})
			.setClassToggle('.image-box--ceo', 'visible')
			.addTo(this._controller);
		new ScrollMagic.Scene({
			triggerElement: '.block--message',
			triggerHook: 'onEnter',
			offset: 50
		})
			.setClassToggle('.block--message', 'visible')
			.addTo(this._controller);

	};


	/**
	 * 沿革
	 *
	 * @memberof CompanyParallax
	 * @return {undefined}
	 */
	historyAnimation() {
		console.log('CompanyParallax.historyAnimation');
		const item = $('.list--history .list__item');
		for(let i = 0; i < item.length; i++){
			new ScrollMagic.Scene({
				triggerElement: item[i],
				triggerHook: 'onEnter',
				offset: 50
			})
				.setClassToggle(item[i], 'visible')
				.addTo(this._controller);
		}
	};
};